export default __webpack_public_path__ + "static/media/Believer's Gloves of Yag.b04b59bc.jpg";